import Alpine from 'alpinejs'

import collapse from '@alpinejs/collapse'
Alpine.plugin(collapse)

import './navigation'

window.Alpine = Alpine
Alpine.start()
